export default {
  register: {
    title: 'साइन अप',
    username: 'उपयोगकर्ता नाम',
    phone: 'फ़ोन नंबर',
    phoneCode: 'कोड',
    email: 'ईमेल',
    password: 'पासवर्ड',
    captcha: 'कैप्चा',
    smsCode: 'SMS कोड',
    emailCode: 'ईमेल कोड',
    verificationCode: 'ईमेल कोड',
    invitationCode: 'निमंत्रण कोड',
    loading: 'लोड हो रहा है...',
    send: 'भेजें',
    sendCode: 'कोड भेजें',
    signUp: 'साइन अप',
    contactUs: 'हमसे संपर्क करें？',
    haveAccount: 'पहले से खाता है?',
    signIn: 'साइन इन',
    loginNow: 'साइन इन करें',
    or: 'या',
    orSignUpWith: 'या इसके साथ साइन अप करें',
    methodUsername: 'उपयोगकर्ता नाम',
    methodPhone: 'फ़ोन',
    methodEmail: 'ईमेल',
    codeOptional: 'कोड (वैकल्पिक)',
    privacyPolicy: 'मैं पुष्टि करता हूं कि मैं 18 वर्ष से अधिक आयु का हूं और स्वीकार करता हूं',
    privacyPolicyLink: 'गोपनीयता नीति',
    and: 'और',
    termsConditions: 'नियम और शर्तें',
    vault: 'तिजोरी',
    receivePromos: 'ईमेल प्रोमो प्राप्त करें',
    usernameRequired: 'उपयोगकर्ता नाम आवश्यक है',
    usernameInvalid: 'उपयोगकर्ता नाम में केवल अक्षर, संख्या और अंडरस्कोर हो सकते हैं',
    phoneRequired: 'फ़ोन नंबर आवश्यक है',
    phoneInvalid: 'अमान्य फ़ोन नंबर प्रारूप',
    emailRequired: 'ईमेल आवश्यक है',
    emailInvalid: 'अमान्य ईमेल प्रारूप',
    passwordRequired: 'पासवर्ड आवश्यक है',
    passwordInvalid: 'पासवर्ड आवश्यकताओं को पूरा नहीं करता',
    captchaRequired: 'कैप्चा आवश्यक है',
    smsCodeRequired: 'SMS कोड आवश्यक है',
    emailCodeRequired: 'ईमेल कोड आवश्यक है',
    privacyPolicyRequired: 'कृपया गोपनीयता नीति और नियम और शर्तों को स्वीकार करें',
    passwordHintLow: 'कम से कम 6 अंक',
    passwordHintMedium: 'अक्षरों और संख्याओं के साथ कम से कम 6 वर्ण',
    passwordHintHigh: 'अक्षरों, संख्याओं और प्रतीकों के साथ कम से कम 6 वर्ण',
    // Format validation
    usernameFormat: 'केवल अक्षर, संख्या और _',
    emailFormat: 'अमान्य ईमेल प्रारूप',
    // Toast messages
    smsCodeSent: 'SMS कोड भेजा गया',
    emailCodeSent: 'ईमेल कोड भेजा गया',
    smsCodeFailed: 'SMS कोड भेजने में विफल',
    emailCodeFailed: 'ईमेल कोड भेजने में विफल',
    registerSuccess: 'पंजीकरण सफल',
    registerFailed: 'पंजीकरण विफल',
    // Google sign in
    signInWithGoogle: 'Google+ से साइन इन करें'
  }
};
